import React, { Fragment, useEffect, useState } from 'react';

import { Button, Flex, Form, Row, Col, Input, Typography, Select, Divider, InputNumber, DatePicker } from 'antd';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { jwtDecode } from 'jwt-decode';

import { createClient, getClient, setIsUpdating as clientIsUpdating, setIsSuccess as clientIsSuccess, updateClient, getByIdClient } from '../administrator/redux/slice';
import { getDesignationListing, getPackagesListing, getUserTypeByIDListing } from '../../redux/slice/global';
import { getDecodeToken } from '../auth/redux/slice';

import BackIcon from '../../components/icon/BackIcon';

import '../../styles/pages/profile-settings.scss';

const { Title, Text } = Typography;

const ClientAddUpdateUser = () => {
    const navigate = useNavigate();

    const [form] = Form.useForm();

    const dispatch = useDispatch();
    const { id } = useParams();
    const listing = useSelector(state => state.listing);
    const auth = useSelector(state => state.auth);
    const client = useSelector(state => state.client);
    const [loginUser, setLoginUser] = useState({});
    const [modalType, setModalType] = useState(false);
    const [userTypesByIDList, setUserTypesByIDList] = useState([]);
    const readyToSave = React.useRef(false);
    const [designationListing, setDesignationListing] = useState([]);
    const { t } = useTranslation()

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            const user = jwtDecode(token);
            dispatch(getDecodeToken(user))
            setLoginUser(user);
        }
    }, [])

    const getPackageLists = () => {
        dispatch(getPackagesListing());
    };

    useEffect(() => {
        if (listing.listing?.designation?.length > 0) {
            setDesignationListing(listing.listing?.designation)
        }
    }, [listing.listing.designation]);

    const handleOnFinish = (values) => {
        readyToSave.current = true;
        if (id) {
            dispatch(clientIsUpdating(false));
        }
        dispatch(getClient({
            ...values,
            isImmutable: client?.client?.isImmutable ? client?.client?.isImmutable : false,
            organizer: id ? client?.client?.organizer : auth?.decodeToken?.organizer,
            package: id ? client?.client?.package : auth?.decodeToken?.package,
            userLimit: client?.client?.userLimit ? client?.client?.userLimit : 0,
            address: { streetNo: values?.streetNo, city: values?.city, zip: values?.zip }
        }));
    }

    useEffect(() => {
        getPackageLists();
        if (loginUser?.organizer) {
            dispatch(getUserTypeByIDListing(loginUser?.organizer));
        }

        if (loginUser?.organizer) {
            dispatch(getDesignationListing(loginUser?.organizer))
        }
    }, [loginUser])

    useEffect(() => {
        if (listing.listing?.userTypeByID?.length > 0) {
            setUserTypesByIDList(listing.listing.userTypeByID);
        }
    }, [listing.listing.userTypeByID, loginUser])

    useEffect(() => {
        if (id) {
            setModalType(true);
            dispatch(clientIsUpdating(true))
            dispatch(getByIdClient(id));
        }
    }, [id]);

    useEffect(() => {
        if (Object.keys(client.client).length > 0) {
            if (!id) {
                if (readyToSave.current) {
                    readyToSave.current = false;
                    dispatch(createClient(client.client));
                }
            } else {
                if (client.isUpdating) {
                    form.setFieldsValue({
                        ...client.client,
                        designation: client.client?.designationId,
                        streetNo: client?.client?.address?.streetNo,
                        city: client?.client?.address?.city,
                        zip: client?.client?.address?.zip,
                        geburtsdatum: client.client?.geburtsdatum ? dayjs(client.client.geburtsdatum) : null,
                        eintrittsdatum: client.client?.eintrittsdatum ? dayjs(client.client.eintrittsdatum) : null,
                        austrittsdatum: client.client?.austrittsdatum ? dayjs(client.client.austrittsdatum) : null,
                    });
                } else if (readyToSave.current) {
                    readyToSave.current = false;
                    dispatch(updateClient({ ...client.client, id: id }));
                }
            }
        }
        if (client.isSuccess) {
            handleClear();
            navigate('/user');
            setModalType(false);
            dispatch(clientIsSuccess(false));
        }
    }, [client.isSuccess, client?.client, client.isUpdating]);

    const handleClear = () => {
        form.resetFields();
    };

    return (
        <Fragment>
            <Flex vertical gap={24} className='user-management general-settings'>
                <Flex justify='space-between' align='center' gap={6} className='w-100' wrap={true}>
                    <Button
                        type='text'
                        icon={<BackIcon role={'button'} />}
                        className='bg-white paddingX-3'
                        onClick={() => navigate('/user')}
                    />
                </Flex>
                <Flex vertical gap={8} className='bg-white padding-2'>
                    <Flex>
                        <Title level={4} type='success'>{id ? t('organizer_usermanagement_user_editUser') : t('organizer_usermanagement_user_addUser')}</Title>
                    </Flex>
                    <Divider />
                    <Form
                        form={form}
                        name='user'
                        colon={true}
                        requiredMark={(label, isRule) => {
                            return <Text>{label}<Text type='danger'>{isRule?.required && '*'}</Text></Text>
                        }}
                        layout='vertical'
                        onFinish={handleOnFinish}
                    >
                        <Fragment>
                            <Row gutter={16}>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Row gutter={24}>
                                        <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                            <Form.Item
                                                name='firstName'
                                                label={t('organizer_common_firstname')}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t('organizer_common_firstnameerror'),
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    placeholder={t('organizer_common_firstname')}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                            <Form.Item
                                                name='lastName'
                                                label={t('organizer_common_lastname')}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t('organizer_common_lastnameerror'),
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    placeholder={t('organizer_common_lastname')}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                            <Form.Item
                                                name='phone'
                                                label={t('organizer_common_phoneNo')}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t('organizer_common_phoneNoerror'),
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    placeholder={t('organizer_common_phoneNo')}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                            <Form.Item
                                                name='email'
                                                label={t('organizer_common_email')}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t('organizer_common_emailerror'),
                                                    },
                                                    {
                                                        type: 'email',
                                                        message: t('organizer_common_emailinvaliderror')
                                                    }
                                                ]}
                                            >
                                                <Input
                                                    placeholder={t('organizer_common_email')}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                            <Form.Item
                                                name='designation'
                                                label={t('organizer_common_designation')}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t('organizer_common_designationerror')
                                                    }
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    allowClear
                                                    filterSort={(optionA, optionB) =>
                                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                                    }
                                                    placeholder={t('organizer_common_designation')}
                                                    options={designationListing}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                            <Form.Item
                                                name='userType'
                                                label={t('organizer_common_usertype')}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t('organizer_common_usertypeerror')
                                                    }
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    allowClear
                                                    filterSort={(optionA, optionB) =>
                                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                                    }
                                                    placeholder={t('organizer_common_usertype')}
                                                    options={userTypesByIDList}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                            <Form.Item
                                                name='employeeType'
                                                label={t('organizer_common_employeetype')}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t('organizer_common_employeetypeerror')
                                                    }
                                                ]}
                                            >
                                                <Select
                                                    showSearch
                                                    allowClear
                                                    filterSort={(optionA, optionB) =>
                                                        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                                    }
                                                    placeholder={t('organizer_common_employeetype')}
                                                    options={[
                                                        {
                                                            value: 'internal',
                                                            label: t('organizer_common_internal')
                                                        },
                                                        {
                                                            value: 'external',
                                                            label: t('organizer_common_external')
                                                        }
                                                    ]}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                            <Form.Item
                                                name='holiday'
                                                label={t('organizer_common_holliday')}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: t('organizer_common_holidayerror')
                                                    }
                                                ]}
                                            >
                                                <Input
                                                    placeholder={t('organizer_common_holliday')}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Title level={5} className='padding-bottom-1'>{t('organizer_common_address')}</Title>
                            <Row gutter={18}>
                                <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                    <Form.Item
                                        name='streetNo'
                                        label={t('organizer_common_streetName')}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('organizer_common_streetnameerror'),
                                            },
                                        ]}
                                    >
                                        <Input
                                            showCount={false}
                                            placeholder={t('organizer_common_streetName')}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                    <Form.Item
                                        name='city'
                                        label={t('organizer_common_city')}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('organizer_common_cityerror'),
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder={t('organizer_common_city')}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                    <Form.Item
                                        name='zip'
                                        label={t('organizer_common_zip')}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('organizer_common_ziperror'),
                                            },
                                            {
                                                pattern: new RegExp(/^[0-9]+$/),
                                                message: t('organizer_common_zipinvaliderror')
                                            }
                                        ]}
                                    >
                                        <Input
                                            placeholder={t('organizer_common_zip')}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Title level={5} className='padding-bottom-2'>{t('organizer_common_shiftmanagement')}</Title>
                            <Row gutter={24}>
                                <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                    <Form.Item
                                        name='workType'
                                        label={t('organizer_common_worktype')}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('organizer_common_worktypeerror')
                                            }
                                        ]}
                                    >
                                        <Select
                                            showSearch
                                            allowClear
                                            filterSort={(optionA, optionB) =>
                                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                            }
                                            placeholder={t('organizer_common_worktype')}
                                            options={[
                                                { value: 'full time', label: t('organizer_common_fulltime') },
                                                { value: 'part time', label: t('organizer_common_parttime') },
                                                { value: 'Minijob', label: 'Minijob' },
                                                { value: 'Werkstudent', label: 'Werkstudent' },
                                                { value: 'Auszubildender', label: 'Auszubildender' },
                                            ]}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                    <Form.Item
                                        name='weeklyWorkHours'
                                        label={t('organizer_common_weeklyhours')}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('organizer_common_weeklyhourserror')
                                            }
                                        ]}
                                    >
                                        <InputNumber
                                            min={1}
                                            className='w-100'
                                            placeholder={t('organizer_common_weeklyhours')}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Fragment>

                        <Title level={5} className='padding-bottom-1' style={{ marginTop: 8 }}>DATEV / Lohnbuchhaltung</Title>
                        <Row gutter={24}>
                            <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                <Form.Item name='personalnummer' label='Personalnummer'>
                                    <Input placeholder='z.B. 1001' />
                                </Form.Item>
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                <Form.Item name='abteilung' label='Abteilung'>
                                    <Input placeholder='z.B. Montage' />
                                </Form.Item>
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                <Form.Item name='kostenstelleStandard' label='Kostenstelle'>
                                    <Input placeholder='z.B. 100' />
                                </Form.Item>
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                <Form.Item name='geburtsdatum' label='Geburtsdatum'>
                                    <DatePicker className='w-100' format='DD.MM.YYYY' placeholder='TT.MM.JJJJ' />
                                </Form.Item>
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                <Form.Item name='geburtsort' label='Geburtsort'>
                                    <Input placeholder='z.B. München' />
                                </Form.Item>
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                <Form.Item name='sozialversicherungsnummer' label='Sozialversicherungsnummer'>
                                    <Input placeholder='z.B. 65 270645 W 017' />
                                </Form.Item>
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                <Form.Item name='steuerIdNummer' label='Steuer-ID'>
                                    <Input placeholder='11-stellige Steuer-ID' />
                                </Form.Item>
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                <Form.Item name='steuerklasse' label='Steuerklasse'>
                                    <Select allowClear placeholder='Bitte wählen'>
                                        {['1', '2', '3', '4', '5', '6'].map(k => (
                                            <Select.Option key={k} value={k}>Klasse {k}</Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                <Form.Item name='konfession' label='Konfession'>
                                    <Select allowClear placeholder='Bitte wählen'>
                                        <Select.Option value='ev'>Evangelisch</Select.Option>
                                        <Select.Option value='rk'>Römisch-Katholisch</Select.Option>
                                        <Select.Option value='lt'>Lutherisch</Select.Option>
                                        <Select.Option value='ak'>Altkatholisch</Select.Option>
                                        <Select.Option value='--'>Keine / Sonstige</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                <Form.Item name='iban' label='IBAN'>
                                    <Input placeholder='DE00 0000 0000 0000 0000 00' />
                                </Form.Item>
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                <Form.Item name='krankenkasse' label='Krankenkasse'>
                                    <Input placeholder='z.B. AOK Bayern' />
                                </Form.Item>
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                <Form.Item name='eintrittsdatum' label='Eintrittsdatum'>
                                    <DatePicker className='w-100' format='DD.MM.YYYY' placeholder='TT.MM.JJJJ' />
                                </Form.Item>
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                                <Form.Item name='austrittsdatum' label='Austrittsdatum'>
                                    <DatePicker className='w-100' format='DD.MM.YYYY' placeholder='TT.MM.JJJJ' />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Flex justify='flex-end' gap={10} wrap={true}>
                            <Button danger type='primary' htmlType='button' onClick={() => navigate(-1)}>{t('organizer_common_cancelButton')}</Button>
                            <Button type='primary' htmlType='submit' loading={client?.loading}>{t('organizer_common_submitButton')}</Button>
                        </Flex>
                    </Form>
                </Flex>
            </Flex>
        </Fragment>
    );
};

export default ClientAddUpdateUser;
